import { HouseIcon } from 'lucide-react';

export const NavHome = HouseIcon;
